<template>
  <portal to="iqos-modal-portal">
    <div class="iqos-modal-wrapper">
      <div class="iqos-modal-backdrop" @click="onBackdropClick"></div>
      <IQOS
        enabled
        class="iqos-modal-content"
        :class="[size]"
      >
        <template #title>
          <slot name="title" />
        </template>

        <div class="mt-16"><slot /></div>

        <BaseDivider color="v1-grey-8" class="mt-16 mb-16" v-if="hasActions" />
        <div class="iqos-modal-actions gap-column-sm" v-if="hasActions">
          <slot name="actions" />
        </div>
      </IQOS>
    </div>
  </portal>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: 'md'
    }
  },
  methods: {
    onBackdropClick() {
      this.$emit("backdropClick");
    },
  },
  computed: {
    hasActions() {
      return !!this.$slots.actions;
    },
  },
  mounted() {
    window.document.body.style.overflow = "hidden";
  },
  beforeDestroy() {
    window.document.body.style.overflow = "initial";
  },
};
</script>

<style scoped>
.iqos-modal-wrapper {
}

.iqos-modal-backdrop {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(237, 237, 237, 0.1);

  backdrop-filter: blur(8px);

  z-index: 10;
}

.iqos-modal-content {
  z-index: 15;
  position: fixed;
  top: 50%;
  left: 50%;

  transform: translate(-50%, -50%);
}

.iqos-modal-content.md {
  width: 540px;
}

.iqos-modal-content.lg {
  width: 720px;
}

.iqos-modal-content.xl {
  width: 1080px;
}

.iqos-modal-content.photoeditor {
  width: 1000px;
}

.iqos-modal-actions {
  display: flex;

  justify-content: space-between;
}
</style>